// pages/PrivacyPolicy/styles.js
import styled from 'styled-components';

export const PolicyWrapper = styled.div`
    min-height: calc(100vh - 72px);
    margin-top: 72px;
    background: ${props => props.theme.colors.background.alt};
`;

export const PolicyHeader = styled.div`
    background: ${props => props.theme.colors.background.paper};
    padding: ${props => props.theme.spacing['3xl']} 0;
    margin-bottom: ${props => props.theme.spacing['3xl']};
    border-bottom: 1px solid ${props => props.theme.colors.border};

    h1 {
        font-size: ${props => props.theme.typography.sizes['4xl']};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.md};

        @media (max-width: ${props => props.theme.breakpoints.md}) {
            font-size: ${props => props.theme.typography.sizes['3xl']};
        }
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
    }
`;

export const PolicyContent = styled.div`
    background: ${props => props.theme.colors.background.paper};
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing['3xl']};
    margin-bottom: ${props => props.theme.spacing['3xl']};

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        padding: ${props => props.theme.spacing.xl};
    }
`;

export const Section = styled.section`
    margin-bottom: ${props => props.theme.spacing['3xl']};

    &:last-child {
        margin-bottom: 0;
    }

    h2 {
        font-size: ${props => props.theme.typography.sizes['2xl']};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.xl};

        @media (max-width: ${props => props.theme.breakpoints.md}) {
            font-size: ${props => props.theme.typography.sizes.xl};
        }
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        line-height: 1.6;
        margin-bottom: ${props => props.theme.spacing.lg};
    }

    ul {
        list-style: none;
        padding-left: ${props => props.theme.spacing.xl};
        margin-bottom: ${props => props.theme.spacing.lg};

        li {
            color: ${props => props.theme.colors.text.secondary};
            margin-bottom: ${props => props.theme.spacing.sm};
            position: relative;

            &:before {
                content: "•";
                color: ${props => props.theme.colors.primary.main};
                position: absolute;
                left: -${props => props.theme.spacing.xl};
            }
        }
    }
`;

export const SubSection = styled.div`
    margin-bottom: ${props => props.theme.spacing.xl};

    h3 {
        font-size: ${props => props.theme.typography.sizes.xl};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.lg};

        @media (max-width: ${props => props.theme.breakpoints.md}) {
            font-size: ${props => props.theme.typography.sizes.lg};
        }
    }
`;